import { Box, Icon, Title, Text, Link } from '@nimbus-ds/components';
import { PencilIcon } from '@nimbus-ds/icons';
import { useTranslationCustomers } from 'domains/Customers/hooks';

interface MetafieldEmptyStateProps {
  handleCreateMetafield: () => void;
}

export default function MetafieldEmptyState({
  handleCreateMetafield,
}: Readonly<MetafieldEmptyStateProps>) {
  const t = useTranslationCustomers();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap="2">
      <Box marginBottom="2">
        <Icon source={<PencilIcon size="large" />} />
      </Box>
      <Title as="h4">
        {t('customerListPage.filterModal.emptyState.title')}
      </Title>
      <Text textAlign="center">
        {t('customerListPage.filterModal.emptyState.description')}
      </Text>
      <Link
        appearance="primary"
        textDecoration="none"
        fontSize="highlight"
        onClick={handleCreateMetafield}
      >
        {t('customerListPage.filterModal.emptyState.link')}
      </Link>
    </Box>
  );
}
